import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles, typographyStyles} from '@webs/components-library/theming';

@customElement('webs-cta-with-avatar')
export class CtaWithAvatar extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`
      .m-cta-with-avatar a {
        align-items: center;
        display: flex;
        text-decoration: none;
      }
      .m-cta-with-avatar .image {
        display: block;
        border-radius: 50%;
        margin-right: 1rem;
        width: 60px;
        height: 60px;
        object-fit: cover;
      }

      .m-cta-with-avatar p {
        color: var(--color-base);
        font-family: var(--font-family-alternative);
        font-size: 0.8rem;
        font-weight: var(--font-weight-strong);
        margin: 0;
        padding-right: 0.5rem;
        transition: color .1s linear;
      }

      .m-cta-with-avatar svg {
        height: 10px;
        transform: translateY(2px);
      }

      .m-cta-with-avatar svg circle {
        transition: fill .1s linear;
      }

      .m-cta-with-avatar a:hover p {
        color: var(--color-primary);
      }

      .m-cta-with-avatar a:hover svg circle {
        fill: var(--color-primary);
      }

      .m-cta-with-avatar--dark p {
        color: var(--color-light-grey);
      }

      .m-cta-with-avatar--dark svg circle {
        fill: var(--color-light-grey);
      }
    `,
  ];

  @property()
  href: string;

  @property({attribute: 'src'})
  imageSrc: string;

  @property({attribute: 'alt'})
  imageAlt: string;

  @property()
  text: 'Talk to our monitiation expert';

  @property()
  theme = 'light';

  protected render(): unknown {
    return html`
      <section class="m-cta-with-avatar ${this.theme ? 'm-cta-with-avatar--' + this.theme : ''}">
        <a href="${this.href}">
          ${this.imageSrc ? html`
            <img src="${this.imageSrc}" alt="${this.imageAlt}" class="image" loading="lazy" width="60"/>` : ''
          }

          <p>${this.text}</p>

          <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="9.29085" cy="6.28523" r="2.4593" fill="#181A23"/>
            <circle cx="2.4593" cy="2.4593" r="2.4593" fill="#181A23"/>
            <circle cx="2.4593" cy="10.1107" r="2.4593" fill="#181A23"/>
          </svg>

        </a>
      </section>
    `;
  }
}
